<template>
    <div component="Contracts">
        <v-data-table
            ref="table"
            :headers="headers"
            :items="contracts"
            :search="search"
            :footer-props="{ 'items-per-page-options': [10, 30, 50, 100] }"
            :page.sync="page"
            fixed-header
            loading-text="Loading... Please wait"
            :items-per-page="50"
            class="table"
        >
            <template v-slot:body="{ items }">
                <tbody>
                    <tr v-for="(item, index) in items" :key="index" @click="openContract(item.id)" :row="index">
                        <td>
                            {{ item.number }}
                        </td>

                        <td>
                            {{ item.project.nazov }}
                        </td>

                        <td>
                            {{ dateFormat(item.date) }}
                        </td>

                        <td>
                            {{ dateFormat(item.sent) }}
                        </td>

                        <td>
                            {{ item.poslana_na_email }}
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
    name: 'Contracts',

    data() {
        return {
            search: '',
            page: 1,
            projectStatus: null,
            projectStatusItems: ['CLOSED', 'APPROVED', 'SENT', 'IN PROGRESS'],
            headers: [
                { text: 'Contract number', value: 'number' },
                { text: 'Project', value: 'project.nazov' },
                { text: 'Created', value: 'date' },
                { text: 'Sent', value: 'sent' },
                { text: 'Sent to', value: 'poslana_na_email' },
            ],
        };
    },

    methods: {
        ...mapActions(['loadContractList']),

        dateFormat(date) {
            if (!date || date === '0000-00-00 00:00:00') {
                return '-';
            }

            return moment(date).format('DD.MM.YYYY');
        },

        openContract(id) {
            this.$router.push({ path: `/contract/${id}` }).catch(() => {});
        },
    },

    computed: {
        ...mapGetters(['getContractList']),

        contracts() {
            const length = this.getContractList.length;
            this.getContractList.map((project, index) => {
                project.index = length - index;
                return project;
            });

            return this.getContractList.filter((i) => {
                return !this.projectStatus || i.project.status === this.projectStatus;
            });
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Contracts'] {
    display: flex;
    flex-direction: column;
    height: 0;
    flex-grow: 1;

    .table {
        display: flex;
        flex-direction: column;
        height: 0;
        flex-grow: 1;

        table {
            overflow: hidden !important;
        }

        tr {
            transition: 0.3s;
            position: relative;
            cursor: pointer;
        }

        .selected {
            td {
                background: fade(@base, 10%);

                &.id {
                    border-radius: 30px 0 0 30px;
                }

                &.action {
                    border-radius: 0 30px 30px 0;
                }
            }
        }

        .id {
            width: 65px;
            border-radius: 30px 0 0 30px !important;
        }

        .date {
            width: 180px;
        }

        .action {
            width: 30px;
            padding-left: 0;
            padding-right: 10px;
            border-radius: 0 30px 30px 0 !important;
        }
    }

    .warning {
        .flex-row;
        justify-content: flex-end;
        position: absolute;
        right: 4px;
        top: 4px;
        height: 40px;
        z-index: 6;
        transition: 0.3s;
        transform: translateX(110%);
        padding: 0 5px 0 20px;
        border-radius: 30px;
        background-color: @primary !important;

        &.show {
            transform: translateX(0);
        }

        .label {
            font-weight: 700;
            color: white;
            margin-right: 10px;
        }

        button {
            margin-left: 3px;
        }
    }
}
</style>
